import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ModalComponent from '../../../components/modal/ModalComponent'
// import OutlinedInput from '../../../components/outlinedInput/OutlinedInput'
import Text from '../../../components/text/Text'
import { useLoadingContext } from '../../../context/spinnerContext'
import routes from '../../../router/routes'
import {
    getCategoriesByCommerce,
    getPlanDetails,
} from '../../../services/products'
import { getStores, ILocalData } from '../../../services/stores'
import polygon from '../../../assets/icons/icons-polygon.png'
import whiteClose from '../../../assets/icons/icons-white-close.png'

import bannerPro from '../../../assets/icons/banner-plan-pro-modal.png'
import bannerStandard from '../../../assets/icons/banner-plan-standard-modal.png'

import check from '../../../assets/icons/check-circle.png'
import locked from '../../../assets/icons/lock-circle.png'
import proTitle from '../../../assets/icons/pro-title-image.png'
import standardTitle from '../../../assets/icons/standard-title-image.png'
import baseTitle from '../../../assets/icons/plan-base-title.png'

import { isAdmin } from '../../../Utils/Profile'
import './StoreMain.css'

interface PlanDetail {
    moduleName?: string
    moduleDescription?: string
    active?: boolean
    color?: string
}
interface Plan {
    id: number
    name: string
    planDetails: PlanDetail[]
}
interface IPlans {
    planId: string
    planName: string
    options: Option[]
}
interface Plan {
    id: number
    name: string
    planDetails: PlanDetail[]
}

const StoreMain = () => {
    const navigate = useNavigate()
    const [storeList, setStoreList] = useState<ILocalData[]>([])
    const [filteredStores, setFilteredStores] = useState<ILocalData[]>([])
    const [searchTerm, setSearchTerm] = useState<string>('')
    const [planDetailModal, setPlanDetailModal] = useState<boolean>(false)
    const [plans, setPlans] = useState<IPlans[]>()
    const [plan, setPlan] = useState<Plan>()
    const [planName, setPlanName] = useState<string>()
    const [selectedFeatureIndex, setSelectedFeatureIndex] = useState<number>(0)
    const [subscritionId, setSubscritionId] = useState<number>()

    const planDetails = plan?.planDetails || []
    const loadingContext = useLoadingContext()

    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser ? JSON.parse(currentUser) : null
    const commerceId = user?.sEstablecimiento

    const getPlan = async (planName: string) => {
        loadingContext?.onOpen()
        try {
            const loweredPlanName = planName.toLocaleLowerCase()
            const planId = loweredPlanName.includes('pro')
                ? 1
                : loweredPlanName.includes('estand')
                ? 3
                : 2
            const response = await getPlanDetails(planId)
            setSubscritionId(response.id)
            setPlan(response)
        } catch (err) {
            console.error('Error al cargar los planes.', err)
        } finally {
            loadingContext?.onClose()
        }
    }

    const getAllStores = async () => {
        loadingContext?.onOpen()
        try {
            const data = await getStores()
            console.log('data de los locales', data)

            if (data.length > 0) {
                setStoreList(data)
                setFilteredStores(data)
            } else {
                setStoreList([])
                setFilteredStores([])
            }
        } catch (err) {
            console.error('Error al cargar los comercios.', err)
        } finally {
            loadingContext?.onClose()
        }
    }

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
        setSearchTerm(value)

        const filtered = storeList.filter((store) =>
            store.description.toLowerCase().includes(value.toLowerCase())
        )
        setFilteredStores(filtered)
    }

    useEffect(() => {
        if (isAdmin()) {
            getAllStores()
        }
    }, [commerceId])

    const handleClosePlanDetailModal = () => {
        setPlanDetailModal(false)
    }

    const featureOptionPro = planDetails.map((item, index) => {
        return {
            featureId: index + 1,
            title: item.moduleName,
            text: item.moduleDescription,
            active: true,
            color: undefined,
            extra: 'true',
        }
    })
    const renderPlanModal = () => {
        return (
            <ModalComponent
                show={planDetailModal}
                modalStyle="store-modal-style"
                icon={false}
            >
                <div
                    style={{
                        width: '100%',
                        marginBottom: 30,
                    }}
                >
                    <div onClick={() => setPlanDetailModal(false)}>
                        <img
                            src={whiteClose}
                            height={24}
                            width={24}
                            style={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                zIndex: 2,
                                cursor: 'pointer',
                            }}
                        />
                    </div>
                    <img
                        src={subscritionId === 1 ? bannerPro : bannerStandard}
                        height={339}
                        width="100%"
                        style={{ marginTop: -40, display: 'block' }}
                    />

                    <div
                        style={{
                            position: 'absolute',
                            top: 70,
                            left: 0,
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            paddingLeft: 30,
                        }}
                    >
                        <Text
                            label="Mi plan"
                            fontSize={20}
                            fontWeight={600}
                            color="white"
                            fontFamily="Poppins"
                        />

                        <div style={{ marginTop: 10 }}>
                            <img
                                src={
                                    subscritionId === 1
                                        ? proTitle
                                        : subscritionId === 2
                                        ? baseTitle
                                        : standardTitle
                                }
                                height={49}
                            />
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        maxHeight: '300px',
                        paddingRight: 16,
                        paddingLeft: 16,
                        paddingBottom: 120,
                    }}
                >
                    <Text
                        label="Funciones disponibles:"
                        fontSize={14}
                        fontWeight={500}
                        color={'#656565'}
                        fontFamily={'Montserrat'}
                        marginLeft={16}
                        marginTop={30}
                        marginBottom={10}
                    />

                    {plan?.planDetails?.map((item, indx) => (
                        <div
                            key={`${item.moduleName}`}
                            className="store-feature-option-item"
                        >
                            <div className="store-flex-direction-row">
                                <img
                                    src={item.active ? check : locked}
                                    height={26}
                                    width={26}
                                />
                                <Text
                                    label={item.moduleName}
                                    fontSize={16}
                                    fontWeight={400}
                                    color={'#464646'}
                                    marginLeft={10}
                                    fontFamily="Montserrat"
                                />

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        flex: 1,
                                        justifyContent: 'end',
                                        minWidth: 90,
                                    }}
                                >
                                    <div
                                        onClick={() => {
                                            setSelectedFeatureIndex(indx)
                                        }}
                                    >
                                        <Text
                                            label="ver más"
                                            fontSize={14}
                                            marginLeft={10}
                                            fontWeight={600}
                                            color={'#0086D6'}
                                            fontFamily="Montserrat"
                                            marginRight={10}
                                        />
                                    </div>

                                    <img
                                        src={polygon}
                                        height={4}
                                        width={6}
                                        color="red"
                                    />
                                </div>
                            </div>
                            {selectedFeatureIndex === indx && (
                                <div className="subscription-feature-text">
                                    <Text
                                        label={item.moduleDescription}
                                        fontSize={14}
                                        fontWeight={400}
                                        color={'#464646'}
                                        fontFamily="Montserrat"
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </ModalComponent>
        )
    }

    const TableItem = ({
        address,
        isActiveMap,
        plan,
        region,
        shopStatus,
        description,
        shopId,
        localId,
    }: ILocalData) => {
        const handleOnClick = async () => {
            localStorage.setItem('selectedLocal', shopId.toString())
            localStorage.setItem('selectedLocalId', localId.toString())
            await getCategoriesByCommerce()
            navigate(`/${routes.localMain}`)
        }
        return (
            <div className="store-list-card" key={description}>
                <div
                    className="store-green-button pointer"
                    onClick={handleOnClick}
                >
                    <Text
                        label="Ver local"
                        fontSize={12}
                        fontWeight={600}
                        color="white"
                    />
                </div>
                <div className="store-local-container">
                    <Text
                        label="Nombre"
                        fontSize={10}
                        fontWeight={400}
                        color="#565656"
                        marginBottom={2}
                    />
                    <Text
                        label={description}
                        fontSize={13}
                        fontWeight={600}
                        color="#565656"
                        whiteSpace="nowrap"
                        variant="store-local-text"
                    />
                </div>
                <div className="store-local-container">
                    <Text
                        label="Dirección"
                        fontSize={10}
                        fontWeight={400}
                        color="#565656"
                        marginBottom={2}
                    />
                    <Text
                        label={address}
                        fontSize={13}
                        fontWeight={600}
                        color="#565656"
                        whiteSpace="nowrap"
                        variant="store-local-text"
                    />
                </div>
                <div className="store-local-container">
                    <Text
                        label="Región"
                        fontSize={10}
                        fontWeight={400}
                        color="#565656"
                        marginBottom={2}
                    />
                    <Text
                        label={region}
                        fontSize={13}
                        fontWeight={600}
                        color="#565656"
                        whiteSpace="nowrap"
                        variant="store-local-text"
                    />
                </div>
                <div className="store-local-container">
                    <Text
                        label="Plan"
                        fontSize={10}
                        fontWeight={400}
                        color="#565656"
                        marginBottom={2}
                    />
                    <div
                        onClick={() => {
                            getPlan(plan.planName)
                            setPlanDetailModal(true)
                            setPlanName(plan.planName)
                        }}
                    >
                        <Text
                            label={plan.planName}
                            fontSize={20}
                            fontFamily={'Nunito'}
                            fontWeight={900}
                            color="#565656"
                            whiteSpace="nowrap"
                            variant={'underline'}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
                <div className="store-local-container-medium">
                    <Text
                        label="Estado"
                        fontSize={10}
                        fontWeight={900}
                        color="#565656"
                        marginBottom={2}
                    />
                    <Text
                        label={shopStatus === 'AC' ? 'Activo' : 'Desvinculado'}
                        fontSize={13}
                        fontWeight={600}
                        color="#565656"
                    />
                </div>
                <div className="store-local-container-small">
                    <Text
                        label="AM"
                        fontSize={10}
                        fontWeight={900}
                        color="#565656"
                        marginBottom={2}
                    />
                    <Text
                        label={isActiveMap ? 'X' : '-'}
                        fontSize={13}
                        fontWeight={600}
                        color="#565656"
                    />
                </div>
            </div>
        )
    }
    return (
        <div>
            <Text
                label="Mis Locales"
                color="#184287"
                fontSize={20}
                fontWeight={600}
                marginBottom={20}
            />
            <div className="main-store-list-card">
                <div className="store-input-container">
                    {/* <div className="store-outlined-input-width">
                        <OutlinedInput
                            placeholder="Busca tu local aquí"
                            charCounter
                            trailingIcon="search"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div> */}
                    {filteredStores.length > 0 ? (
                        filteredStores.map((store, index) => (
                            <TableItem {...store} key={store.region} />
                        ))
                    ) : (
                        <Text
                            label="No se encontraron locales."
                            fontSize={14}
                            color="#565656"
                        />
                    )}
                </div>
            </div>
            {renderPlanModal()}
        </div>
    )
}

export default StoreMain
